import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

export default class Scroll {
    constructor () {
        document.addEventListener('click', (e) => {
            const el = e.target.tagName === 'A' ? e.target : e.target.closest('a')
            if (el && el.matches('a[href^="#"]') && el.hash.length > 1) {
                e.preventDefault()
                this.handleScroll(el.hash)
            }
        })
    }

    handleScroll (el) {
        if (typeof el === 'string') {
            el = document.querySelector(el)
        }
        if (el) {
            Scroll.scrollToEl(el)
        }
    }

    static scrollToEl (el,  args = {}) {
        const yOffset = args.offset ? args.offset : 0 
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({
            top: y,
            behavior: 'smooth',
        })
    }
}